module.exports = __webpack_public_path__ + "img/10-9.bba21fa8.jpg";